import React from "react";
import { withStyles } from "@material-ui/core/styles";
import {
  Paper,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow
} from "@material-ui/core";
import { gql, useQuery } from "@apollo/client";
import { useParams } from "react-router-dom";
import TournamentList from "./TournamentList";
import TableLink from "../TableLink";

const styles = theme => ({
  root: {
    maxWidth: 1200,
    marginTop: theme.spacing(5),
    padding: theme.spacing(2),
    overflowX: "auto",
    margin: "auto"
  }
});

const GET_QUESTION_SET = gql`
  query questionSetQuery($id: Int) {
    QuestionSet(id: $id) {
      name
      pp20tuh
      ppb
      difficulty {
        name
      }
    }
  }
`;

function QuestionSet({ classes }) {
  const { id } = useParams();
  const { loading, data, error } = useQuery(GET_QUESTION_SET, {
    variables: {
      id: parseInt(id)
    }
  });

  return (
    <Paper className={classes.root}>
      {loading && !error && <p>Loading...</p>}
      {error && !loading && <p>Error</p>}
      {data && !loading && !error && (
        <div>
          <Typography variant="h4" gutterBottom>
            {data.QuestionSet[0].name}
          </Typography>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Difficulty</TableCell>
                <TableCell>PP20TUH</TableCell>
                <TableCell>PPB</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              <TableRow>
                <TableCell>
                  {data.QuestionSet[0].difficulty?.name || "Unknown"}
                </TableCell>
                <TableCell>
                  {data.QuestionSet[0]?.pp20tuh?.toFixed(2) || "N/A"}
                </TableCell>
                <TableCell>
                  {data.QuestionSet[0]?.ppb?.toFixed(2) || "N/A"}
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
          <TournamentList questionSetId={parseInt(id)}></TournamentList>
          <Typography variant="h5" gutterBottom>
            Performances
          </Typography>
          <Typography variant="body1" gutterBottom>
            <TableLink
              to={`/record/individual-game?order=desc&orderBy=points&questionSets=${id}`}
            >
              Best Player Game Performances
            </TableLink>
          </Typography>
          <Typography variant="body1" gutterBottom>
            <TableLink
              to={`/record/individual-tournament?order=desc&orderBy=points&questionSets=${id}`}
            >
              Best Player Tournament Performances
            </TableLink>
          </Typography>
          <Typography variant="body1" gutterBottom>
            <TableLink
              to={`/record/team-game?order=desc&orderBy=points&questionSets=${id}`}
            >
              Best Team Game Performances
            </TableLink>
          </Typography>
          <Typography variant="body1" gutterBottom>
            <TableLink
              to={`/record/team-tournament?order=desc&orderBy=points&questionSets=${id}`}
            >
              Best Team Tournament Performances
            </TableLink>
          </Typography>
        </div>
      )}
    </Paper>
  );
}

export default withStyles(styles)(QuestionSet);
